

angular
.module('inkfinder')
.factory('CheckCollisions', function CheckCollisions(
  $q,
  ScheduleUtilFactory,
  ShopHours,
  Session,
  moment,
  RESPONSE_MESSAGES
) {
  // Public methods
  CheckCollisions.check = check;

  /**
  * @name check
  * @description Takes an appointment and set of availability data and returns
  * a set of errors and warnings based on overlap between the appointment and
  * availability blocks/other appointments.
  * @param {unknown} availableInput Unknown.
  * @param {unknown} appointmentInput Unknown.
  * @param {unknown} inputBlock Unknown.
  * @param {unknown} appointment Unknown.
  * @return {unknown} Unknown
  */
  function check(availableInput, appointmentInput, inputBlock, appointment) {
    return $q(function(resolve, reject) {
      ShopHours.get(Session.activeState.association.shop.id)
      .then(function(hours) {
        let start = appointment.start;
        let end = appointment.end;
        let id = (appointment.id ? appointment.id : null);

        let errors = [];
        let warnings = [];
        let outsideShopHours = false;

        let shopHours = ScheduleUtilFactory.getShopTimes(
          hours.all,
          inputBlock.start);
        let shopStart = shopHours.earliest.start;
        let shopEnd = shopHours.latest.end;

        if (inputBlock.end < shopStart) {
          shopHours = ScheduleUtilFactory.getShopTimes(
            hours.all,
            moment(inputBlock.start).subtract(1, 'day')
          );
          shopStart = shopHours.earliest.start;
          shopEnd = shopHours.latest.end;
        }

        // If the shop isn't open on the day in question, they may be trying to schedule something for the next day
        if (start < shopStart || end > shopEnd) {
          // Increment the dates by 1 and try one last time
          start.add(1, 'day');
          end.add(1, 'day');

          if (start < shopStart || end > shopEnd) {
            errors.push(RESPONSE_MESSAGES.outsideShopHours.message);
            outsideShopHours = true;
          } else {
            warnings.push('This appointment starts on ' +
            start.format('MMMM Do [at] h:mm a'));
          }
        }
        if (!outsideShopHours) {
          let appointments = ScheduleUtilFactory.getRulesInRange(
            appointmentInput,
            shopStart,
            shopEnd
          );
          let available = ScheduleUtilFactory.getRulesInRange(
            availableInput,
            shopStart,
            shopEnd
          );
          let overlappingAppointments = ScheduleUtilFactory.getRulesInRange(
            appointments,
            start,
            end
          );
          let overlap = false;
          for (let i = 0; i < overlappingAppointments.length; i++) {
            if (overlappingAppointments[i].appointment.id !== id) {
              overlap = true;
            }
          }
          if (overlap) {
            errors.push(RESPONSE_MESSAGES.existingAppointment.message);
          } else {
            let fitsSchedule = false;
            for (let x = 0; x < available.length; x++) {
              let block = available[x];
              if (block.start <= start && end <= block.end) {
                fitsSchedule = true;
                break;
              }
            }
            let sameAppointment = false;
            for (let i = 0; i < overlappingAppointments.length; i++) {
              if (overlappingAppointments[i].appointment.id === id) {
                sameAppointment = true;
              }
            }
            if (!fitsSchedule && !sameAppointment) {
              warnings.push(RESPONSE_MESSAGES.artistNotScheduled.message);
            } else if (!fitsSchedule && sameAppointment) {
              warnings.push(RESPONSE_MESSAGES.sameAppointmentTime.message);
            }
          }
        }
        resolve({
          errors: errors,
          warnings: warnings
        });
      });
    });
  }
  return CheckCollisions;
});



// WEBPACK FOOTER //
// ./components/schedule/util/check-collision.service.js